import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Grid } from '@mui/material';
import BenefitDetailCard from './BenefitDetailCard';
import FYDetailsSection from './FYDetailsSection';
import NPSOverviewSection from './NPSOverviewSection';
import { useLocation, useNavigate } from 'react-router-dom';
import { GAPDetailAction } from '../APIs/action';
import { toast } from 'react-toastify';


const GAPDetailPage = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const selectedManufacturer = location.state?.selectedManufacturer;
	const selectedCompanyEntity = location.state?.selectedCompanyEntity;

	const [gapDetail, setGapDetail] = useState([]);
	const [loader, setLoader] = useState(false);


	const getGAPDetail = async (selectedManufacturer, selectedCompanyEntity) => {
		setLoader(true);
		const { data, message, error } = await GAPDetailAction(selectedManufacturer, selectedCompanyEntity);
		setLoader(false);
		if (!error) {
			setGapDetail(data);
		} else {
			toast.error(message);
		}
	};
	useEffect(()=>{
		if(selectedManufacturer && selectedCompanyEntity){
			getGAPDetail(selectedManufacturer, selectedCompanyEntity);
		}else{
			navigate('/benefits/mybenefits', { replace: true });
		}
	},[ selectedManufacturer, selectedCompanyEntity])
	if (loader) {
		return (
			<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
				<CircularProgress/>
			</Box>
		);
	}

	const benefitDetails = gapDetail?.benefit_card || {};
	const fyDetails = gapDetail?.fy_details || [];
	const subject_to_tds = gapDetail?.subject_to_tds;	
	
	return (
		<Box sx={{ p: { xs: 2, md: 3 } }}>
			<Grid container spacing={{ xs: 2, md: 3 }}>
				{/* LEFT COLUMN: BenefitDetailCard + (optional) gapDisbursed + NPSOverviewSection */}
				<Grid item xs={12} md={6}>
					<Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 2, md: 3 } }}>
						<Box
							sx={{
								display: 'flex',
								flexDirection: 'column',
								p: 2,
								background: '#ffffff',
								border: '1px solid #D9D9D9',
								borderRadius: 2,
							}}
						>
							<BenefitDetailCard benefitDetails={benefitDetails} spacing={false} />
						</Box>
					</Box>
				</Grid>
				{/* RIGHT COLUMN: FYDetailsSection */}
				{fyDetails && (
					<Grid item xs={12} md={6}>
						<Box>
							<FYDetailsSection fyDetails={fyDetails} subject_to_tds={subject_to_tds} />
						</Box>
					</Grid>
				)}
			</Grid>
		</Box>
  	);
};

export default GAPDetailPage;
